module.exports = __webpack_public_path__ + "img/number.b3c3cb74.svg";